export * from './file-uploader.component';
export * from './file-uploader.module';
